module.exports = __webpack_public_path__ + "static/media/lds-logo_fr.9eb025ba.svg";